module.exports = __webpack_public_path__ + "img/news-3.183715c7.jpg";